import { module } from 'angular';

import { ButtonDirective, default as buttonDirectiveName } from './button.directive';

export default module('contact.commons.toolbox.button', []).directive(buttonDirectiveName, ButtonDirective).name;
